import Vue from 'vue'
import VueRouter from 'vue-router'
import Home2 from '@/views/Home2'
import paymentSuccess from '@/views/paymentSuccess'
import paymentCancled from '@/views/paymentCancled'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home2
  },
  {
    path: '/success',
    name: 'Success',
    component: paymentSuccess
  }, {
    path: '/canceled',
    name: 'canceled',
    component: paymentCancled
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
